'use client'

import { useEffect, useRef } from 'react'
import { useParams, usePathname } from 'next/navigation'

import { useProjectsStore } from '@common/modules/projects/stores/projects.store'
import { useWorkspacesStore } from '@common/modules/workspaces/stores/workspaces.store'

import { redirectToPortal } from '../components/Layout/utils/redirectToPortal'
import { isAcceptInvitationRoute } from '../utils/isAcceptInvitationRoute'
import { isPortalAppOnClient } from '../utils/isPortalApp'

type UseFirstTimeUserPortalRedirectParams = {
  isEmailVerified: boolean
  isInitializing: boolean
  isOnboarding: boolean
}

export function useFirstTimeUserPortalRedirect({
  isEmailVerified,
  isInitializing,
  isOnboarding,
}: UseFirstTimeUserPortalRedirectParams) {
  const pathname = usePathname()
  const { locale } = useParams()
  const currentWorkspace = useWorkspacesStore((s) => s.currentWorkspace)
  const currentProject = useProjectsStore((s) => s.currentProject)
  const redirectStartedRef = useRef(false)

  useEffect(() => {
    if (isPortalAppOnClient()) return
    if (isAcceptInvitationRoute(pathname)) return
    if (!isEmailVerified || isInitializing || isOnboarding) return
    if (currentWorkspace && currentProject) return
    if (redirectStartedRef.current) return

    redirectStartedRef.current = true
    redirectToPortal('', typeof locale === 'string' ? locale : 'en')
  }, [pathname, locale, isEmailVerified, isInitializing, isOnboarding, currentWorkspace, currentProject])
}
